import React from 'react';

export const positions = [
  'top-left',
  'top-center',
  'top-right',
  'center-right',
  'bottom-right',
  'bottom-center',
  'bottom-left',
  'center-left',
] as const;

export interface ResizeHandlerOptions {
  resizeActive: boolean;
  setResizeActive: React.Dispatch<React.SetStateAction<boolean>>;
  resizeBoxRef: React.RefObject<HTMLDivElement>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateAttributes: (attributes: Record<string, any>) => void;
}

export function resizeHandler({
  resizeActive,
  setResizeActive,
  resizeBoxRef,
  updateAttributes,
}: ResizeHandlerOptions) {
  return (
    pos: (typeof positions)[number],
    mouseDownEvent: React.MouseEvent<HTMLElement>,
  ) => {
    if (resizeActive) return;
    setResizeActive(true);
    // const image = imageRef.current;
    // if (image === null) return;
    const startX = mouseDownEvent.pageX;
    const startY = mouseDownEvent.pageY;
    const resizeBox = resizeBoxRef.current;
    if (resizeBox === null) return;
    const originalAspectRatio = resizeBox.clientHeight
      ? resizeBox.clientWidth / resizeBox.clientHeight
      : 1;

    const oldWidth = resizeBox.clientWidth;
    const oldHeight = resizeBox.clientHeight;

    let widthChange = 0;
    let heightChange = 0;
    let x = 0;
    let y = 0;
    let aspectRatio = 0;

    function onMouseMove(mouseMoveEvent: MouseEvent) {
      if (resizeBox === null) return;

      switch (pos) {
        case 'top-left':
          x = startX - mouseMoveEvent.pageX;
          y = startY - mouseMoveEvent.pageY;
          ({ widthChange, heightChange } = getHeightAndWidth(
            x,
            y,
            originalAspectRatio,
          ));
          resizeBox.style.top = `${-heightChange}px`;
          resizeBox.style.left = `${-widthChange}px`;
          break;
        case 'top-center':
          y = startY - mouseMoveEvent.pageY;
          heightChange = y;
          widthChange = heightChange * originalAspectRatio;
          resizeBox.style.top = `${-heightChange}px`;
          resizeBox.style.left = `${Math.round(-widthChange / 2)}px`;
          resizeBox.style.right = `${Math.round(-widthChange / 2)}px`;

          break;
        case 'top-right':
          x = mouseMoveEvent.pageX - startX;
          y = startY - mouseMoveEvent.pageY;
          ({ widthChange, heightChange } = getHeightAndWidth(
            x,
            y,
            originalAspectRatio,
          ));
          resizeBox.style.top = `${-heightChange}px`;
          resizeBox.style.right = `${-widthChange}px`;

          break;
        case 'center-right':
          x = mouseMoveEvent.pageX - startX;
          widthChange = x;
          heightChange = widthChange / originalAspectRatio;
          resizeBox.style.right = `${-widthChange}px`;
          resizeBox.style.top = `${-Math.round(heightChange / 2)}px`;
          resizeBox.style.bottom = `${-Math.round(heightChange / 2)}px`;

          break;
        case 'bottom-right':
          x = mouseMoveEvent.pageX - startX;
          y = mouseMoveEvent.pageY - startY;
          ({ widthChange, heightChange } = getHeightAndWidth(
            x,
            y,
            originalAspectRatio,
          ));
          resizeBox.style.bottom = `${-heightChange}px`;
          resizeBox.style.right = `${-widthChange}px`;

          break;
        case 'bottom-center':
          y = mouseMoveEvent.pageY - startY;
          heightChange = y;
          widthChange = heightChange * originalAspectRatio;
          resizeBox.style.bottom = `${-heightChange}px`;
          resizeBox.style.left = `${Math.round(-widthChange / 2)}px`;
          resizeBox.style.right = `${Math.round(-widthChange / 2)}px`;

          break;
        case 'bottom-left':
          x = startX - mouseMoveEvent.pageX;
          y = mouseMoveEvent.pageY - startY;
          ({ widthChange, heightChange } = getHeightAndWidth(
            x,
            y,
            originalAspectRatio,
          ));
          resizeBox.style.bottom = `${-heightChange}px`;
          resizeBox.style.left = `${-widthChange}px`;

          break;
        case 'center-left':
          x = startX - mouseMoveEvent.pageX;
          widthChange = x;
          heightChange = widthChange / originalAspectRatio;
          resizeBox.style.left = `${-widthChange}px`;
          resizeBox.style.top = `${Math.round(-heightChange / 2)}px`;
          resizeBox.style.bottom = `${Math.round(-heightChange / 2)}px`;

          break;
      }
      aspectRatio = widthChange / heightChange;
      console.table({
        widthChange,
        heightChange,
        startX,
        x,
        startY,
        y,
        originalAspectRatio,
        aspectRatio,
      });
    }
    function onMouseUp() {
      document.body.removeEventListener('mousemove', onMouseMove);
      setResizeActive(false);
      // const image = imageRef.current;
      // if (image === null) return;
      const newWidth = oldWidth + widthChange;
      const newHeight = oldHeight + heightChange;
      console.log({ oldWidth, oldHeight, newWidth, newHeight });
      // image.width = newWidth;
      // image.height = newHeight;
      if (resizeBox === null) return;
      resizeBox.style.top = '0';
      resizeBox.style.left = '0';
      resizeBox.style.right = '0';
      resizeBox.style.bottom = '0';
      updateAttributes({
        width: newWidth,
        height: newHeight,
      });
    }

    document.body.addEventListener('mousemove', onMouseMove);
    document.body.addEventListener('mouseup', onMouseUp, { once: true });
  };
}

function getHeightAndWidth(x: number, y: number, originalAspectRatio: number) {
  let widthChange = 0;
  let heightChange = 0;
  if (Math.abs(x) > Math.abs(y)) {
    widthChange = x;
    heightChange = widthChange / originalAspectRatio;
  } else {
    heightChange = y;
    widthChange = heightChange * originalAspectRatio;
  }
  return { widthChange, heightChange };
}
